module.exports = __webpack_public_path__ + "img/bottom_bg.90c1ea1.90c1ea16.jpg";